import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useUserPropertiesPreferencesQuery } from '@/gql/myomr'

export function useFormData() {
  const { t } = useI18n()

  const titleOptions = [
    { value: '', text: '' },
    { value: 'dr', text: t('form.values.title.dr') },
    { value: 'prof', text: t('form.values.title.prof') },
    { value: 'prof_dr', text: t('form.values.title.prof_dr') },
    { value: 'ing', text: t('form.values.title.ing') },
    { value: 'dipl_ing', text: t('form.values.title.dipl_ing') },
    { value: 'mag', text: t('form.values.title.mag') },
  ]

  const { result: userPropertiesResult } = useUserPropertiesPreferencesQuery({ fetchPolicy: 'cache-first' })

  const countries = computed(() => userPropertiesResult.value?.userPropertiesPreferences.countries ?? [])
  const salutations = computed(() => userPropertiesResult.value?.userPropertiesPreferences.salutations ?? [])
  const jobLevels = computed(() => userPropertiesResult.value?.userPropertiesPreferences.jobLevels ?? [])
  const companySizes = computed(() => userPropertiesResult.value?.userPropertiesPreferences.companySizes ?? [])
  const companyTypes = computed(() => userPropertiesResult.value?.userPropertiesPreferences.companyTypes ?? [])
  const companyIndustries = computed(() => userPropertiesResult.value?.userPropertiesPreferences.companyIndustries ?? [])
  const companyFields = computed(() => userPropertiesResult.value?.userPropertiesPreferences.companyFields ?? [])
  const companyDepartments = computed(() => userPropertiesResult.value?.userPropertiesPreferences.companyDepartments ?? [])

  return {
    salutationOptions: salutations,
    titleOptions,
    countries,
    jobLevels,
    companySizes,
    companyTypes,
    companyIndustries,
    companyFields,
    companyDepartments,
  }
}
